import React from 'react';
import './LandingPage.css';

export default function AddLocalMember() {
  return (
    <main className="container" style={{ padding: 24 }}>
      <h1>Add Local Member</h1>
      <p>Form/page to add a local member (placeholder).</p>
    </main>
  );
}
